export default __webpack_public_path__ + "static/max-yc-046afe737e286652472ccae2916d3a06.png";